import React, { useState, useEffect, useRef } from "react";
import { useTenantContent } from "../../Context/TenantContentContext";
import {
  fetchAvailableDates,
  fetchAvailableSlots,
  requestPayment,
  fetchAvailableMonths,
  getFirstAvailableSlot,
  getReservationInfo,
  createReserveWithNoDeposite,
} from "../../Services/ReservationService";
import Loader from "../../Components/Core/Loader";
import ReservaDateTimeItme from "../../Components/Reservation/ReservaDateTimeItme";
import ReserveSlotItme from "../../Components/Reservation/ReserveSlotItme";
import { isLoggedIn } from "../../Services/AuthService";
import { useNavigate } from "react-router-dom";
import Notification from "../../Components/Core/Notification";
import ConfirmModal from "../../Components/Modals/ConfirmModal";
import SeoHead from "../../Components/Core/SeoHead";
import { formatDate, getDecodedUserId } from "../../Services/GeneralService";
import { redirectToPaymentGateway } from "../../Services/paymentRedirect";
import ReservaMonthItem from "../../Components/Reservation/ReservaMonthItem";
import InfoModal from "../../Components/Modals/InfoModal";
import GatewaySelector from "../../Components/Payment/GatewaySelector";
import SupportWidget from "../../Components/Core/SupportWidget";
import { doctorDisplayName, joinUrl } from "../../utils/seo";
import {
  ReservationContainer,
  MainCard,
  SectionHeader,
  ScrollContainer,
  EmptyStateCard,
  StyledButton,
  ReservationSection,
  FinalActionContainer,
  LoaderContainer,
} from "./Reserve.styles";

const Reserve = () => {
  const [availableMonths, setAvailableMonths] = useState([]);
  const [reserveInfo, setReserveInfo] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDateDisplay, setSelectedDateDisplay] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [slotLoading, setSlotLoading] = useState(false);
  const [dayLoading, setDayLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isInitila, setIsInitial] = useState(true);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState("zarinpal");
  const { content, loading: contentLoading } = useTenantContent();

  const navigate = useNavigate();
  const dateRefs = useRef({});
  const monthSectionRef = useRef(null);
  const daySectionRef = useRef(null);
  const slotSectionRef = useRef(null);
  const finalButtonRef = useRef(null);

  const scrollToSection = (ref) => {
    setTimeout(() => {
      if (ref?.current) {
        ref.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100); // یه تاخیر کوچیک برای رندر
  };

  useEffect(() => {
    const lastShown = localStorage.getItem("reserveInfoModalLastShown");
    const now = Date.now();
    const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;

    if (!lastShown || now - parseInt(lastShown, 10) > oneWeekInMs) {
      setOpenInfoModal(true);
    }

    const FetchAvailableMonths = async () => {
      try {
        const months = await fetchAvailableMonths();
        setAvailableMonths(months);
        if (months.length > 0) {
          handleMonthClick(months[0], null, false);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchFee = async () => {
      try {
        const info = await getReservationInfo();
        setReserveInfo(info);
      } catch (error) {
        console.error("Error fetching reservation fee:", error);
      }
    };

    FetchAvailableMonths();
    fetchFee();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedDate && dateRefs.current[selectedDate]) {
      const target = dateRefs.current[selectedDate];
      // Scroll the selected date into view of the nearest horizontal scroller.
      // This is more reliable on mobile than manually calculating scrollLeft.
      target.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [selectedDate]);

  const handleMonthClick = async (MonthVM, dayVM, isUserAction = true) => {
    try {
      setDayLoading(true);
      setSelectedMonth(MonthVM);
      setSelectedDate(null);
      setSelectedSlot(null);

      const availableDates = await fetchAvailableDates(MonthVM);
      setAvailableDates(availableDates);

      if (isInitila && availableDates.length > 0 && !isUserAction) {
        // انتخاب خودکار → فقط تاریخ و اسلات رو ست کن، اسکرول نکن
        handleDateClick(
          availableDates[0].date,
          availableDates[0].dateDisplay,
          false // اینجا پاس بده
        );
        setIsInitial(false);
      } else if (dayVM) {
        handleDateClick(dayVM.date, dayVM.dateDisplay, isUserAction);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDayLoading(false);
      if (isUserAction) {
        scrollToSection(daySectionRef); // فقط وقتی کاربر کلیک کرد
      }
    }
  };

  const handleDateClick = async (date, dateDisplay, isUserAction = true) => {
    setSelectedSlot(null);
    setSelectedDate(date);
    setSelectedDateDisplay(dateDisplay);
    setSlotLoading(true);
    try {
      const slots = await fetchAvailableSlots(date);
      setAvailableSlots(slots);
    } catch (error) {
      console.error("Error fetching slots:", error);
      setSnackbarMessage(error.message);
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setSlotLoading(false);
      if (isUserAction) {
        scrollToSection(slotSectionRef); // فقط وقتی کاربر انتخاب کرد
      }
    }
  };

  const handleSlotClick = (slot) => {
    setSelectedSlot(slot);
    scrollToSection(finalButtonRef);
  };

  const handleOpenDialog = () => {
    if (!isLoggedIn()) {
      navigate("/login", { state: { from: "/reservation/reserve" } });
    }
    setOpenDialog(true);
  };

  const handleInfoModalClose = () => {
    setOpenInfoModal(false);
    localStorage.setItem("reserveInfoModalLastShown", Date.now().toString());
  };

  const paymentGatewayMethod = Number(
    reserveInfo?.paymentGatewayMethod ?? content?.paymentGatewayMethod ?? 1
  );
  const isPublicGateway = paymentGatewayMethod === 1;
  const canShowGatewaySelector = isPublicGateway;

  const handleConfirmReservation = async () => {
    if (selectedSlot) {
      try {
        setLoading(true);
        const reserveDetail = {
          StartTime: selectedSlot,
          Date: formatDate(selectedDate),
          UserId: getDecodedUserId(),
          Gateway: canShowGatewaySelector ? selectedGateway : "zarinpal",
        };
        if (!reserveInfo.isReservationDepositeActive) {
          const createReserve = await createReserveWithNoDeposite(
            reserveDetail
          );
          if (
            createReserve.reservationId != null &&
            createReserve.reservationId !== 0
          ) {
            navigate(
              `/reservation/detail/success/${createReserve.reservationId}`
            );
          }
        } else {
          const requestResponse = await requestPayment(reserveDetail);
          if (
            requestResponse.code === 100 &&
            (requestResponse.authority || requestResponse.token)
          ) {
            localStorage.setItem(
              "reserveDetail",
              JSON.stringify(reserveDetail)
            ); // should move to back
            redirectToPaymentGateway(requestResponse);
          } else {
            console.log("Payment request failed!");
            setSelectedSlot(null);
          }
        }
      } catch (error) {
        setLoading(false);
        setSnackbarMessage(error.message);
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        console.error(error);
      } finally {
        setOpenDialog(false);
      }
    }
  };

  const firstEmptySlotHandler = async () => {
    try {
      setLoading(true);
      const firstSlot = await getFirstAvailableSlot();
      setLoading(false);
      await handleMonthClick(firstSlot.month, firstSlot.day);
    } catch (error) {
      setSnackbarMessage(error.message);
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      // setDayLoading(false);
    }
  };

  if (contentLoading || loading || !content) {
    return <Loader />;
  }

  const modalTextLines = [
    `مطمئن هستید که میخواهید تاریخ ${selectedDateDisplay} ساعت ${selectedSlot} را رزرو کنید؟`,
    "چنانچه رزرو شما موفقیت‌آمیز باشد، پیامی شامل مشخصات رزرو برای شما ارسال خواهد شد, در غیر این صورت با پشتیباتی تماس بگیرید",
    "",
    "در صورتی که با مشکل مواجه شدید، می‌توانید با پشتیبانی (از طریق ایکون پشتیبانی در پایین صفحه) تماس بگیرید",
  ];

  if (reserveInfo && reserveInfo.isReservationDepositeActive) {
    modalTextLines.push(
      `لازم به ذکر است مبلغ ${reserveInfo.reservationFee} هزار تومان به عنوان بیعانه و مابقی مبلغ پس از مراجعه به مطب پرداخت خواهد شد`
    );
    if (!canShowGatewaySelector) {
      modalTextLines.push("درگاه پرداخت زرین پال میباشد");
    }
  }

  return (
    <>
      <SeoHead
        title={`رزرو نوبت اینترنتی ${doctorDisplayName(content)} | ${content.siteName}`}
        description={`سامانه نوبت‌دهی آنلاین مطب ${doctorDisplayName(content)}${
          content.doctorSpecialty ? `، ${content.doctorSpecialty}` : ""
        }. دریافت نوبت سریع و آسان.`}
        keywords={content.siteKeywords}
        canonical={joinUrl(content.canonicalUrl, "reservation/reserve")}
        image={content.ogImage || content.doctorImageUrl}
        imageAlt={doctorDisplayName(content)}
        siteName={content.siteName}
      />

      <InfoModal
        handleCloseDialog={handleInfoModalClose}
        openDialog={openInfoModal}
        title={content?.reserveInfoModalTitle || "راهنمای رزرو نوبت"}
        text={content?.reserveInfoModalContent || []}
        confirnButtonText={"ادامه رزرو"}
        requireAcknowledgement
        acknowledgementText={"توضیحات بالا را خواندم"}
      />

      <ReservationContainer>
        <MainCard className="container-fluid">
          <h1 className="iran-sans color-blue fw-bold mb-4" style={{ fontSize: "1.6rem" }}>
            رزرو نوبت اینترنتی
          </h1>
          {loading ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <>
              <ReservationSection ref={monthSectionRef}>
                <SectionHeader>
                  <span>انتخاب ماه</span>
                </SectionHeader>
                <ScrollContainer>
                  {availableMonths.map((itm, index) => (
                    <ReservaMonthItem
                      selectedMonth={selectedMonth}
                      itm={itm}
                      handleDateClick={handleMonthClick}
                      key={index}
                    />
                  ))}
                </ScrollContainer>
              </ReservationSection>

              {selectedMonth && (
                <>
                  {dayLoading ? (
                    <LoaderContainer>
                      <Loader />
                    </LoaderContainer>
                  ) : (
                    <>
                      <ReservationSection ref={daySectionRef}>
                        <SectionHeader>
                          <span>انتخاب روز</span>
                        </SectionHeader>
                        <ScrollContainer>
                          {availableDates.map((itm, index) => (
                            <ReservaDateTimeItme
                              ref={(el) => (dateRefs.current[itm.date] = el)}
                              selectedDate={selectedDate}
                              itm={itm}
                              handleDateClick={async () => {
                                await handleDateClick(itm.date, itm.dateDisplay);
                              }}
                              key={index}
                              showAvailableCount={content.showAvailibaleTimeCount}
                            />
                          ))}
                        </ScrollContainer>
                      </ReservationSection>

                      {selectedDate && (
                        <>
                          {slotLoading ? (
                            <LoaderContainer>
                              <Loader />
                            </LoaderContainer>
                          ) : (
                            <>
                              {availableSlots.length === 0 ? (
                                <EmptyStateCard>
                                  <div className="row mb-4">
                                    <span className="color-blue fw-bold">
                                      {" "}
                                      در این روز زمان رزرو موجود نیست!
                                    </span>
                                  </div>
                                  <StyledButton
                                    variant="contained"
                                    color="success"
                                    onClick={firstEmptySlotHandler}
                                  >
                                    <span>اولین نوبت آزاد بعدی</span>
                                  </StyledButton>
                                </EmptyStateCard>
                              ) : (
                                <ReservationSection ref={slotSectionRef}>
                                  <SectionHeader>
                                    <span>انتخاب ساعت</span>
                                  </SectionHeader>
                                  <div className="row gx-4 p-3 g-md-3 pe-1 ps-sm-3 pe-md-0">
                                    {availableSlots.map((slot, index) => (
                                      <ReserveSlotItme
                                        // className="m-5 g-4"
                                        selectedSlot={selectedSlot}
                                        slot={slot}
                                        handleSlotClick={handleSlotClick}
                                        key={index}
                                      />
                                    ))}
                                  </div>
                                </ReservationSection>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              {selectedSlot && (
                <FinalActionContainer ref={finalButtonRef}>
                  <StyledButton
                    className="mb-4 mb-md-0"
                    variant="contained"
                    color="success"
                    onClick={handleOpenDialog}
                  >
                    <span>رزرو نوبت</span>
                  </StyledButton>
                </FinalActionContainer>
              )}
            </>
          )}
        </MainCard>
      </ReservationContainer>

      <ConfirmModal
        handleCloseDialog={() => setOpenDialog(false)}
        handleConfirm={handleConfirmReservation}
        text={modalTextLines}
        openDialog={openDialog}
        confirmText={"پرداخت"}
        cancleText={"خیر"}
        title={"تایید رزرو"}
      >
        {reserveInfo?.isReservationDepositeActive && canShowGatewaySelector && (
          <div style={{ marginTop: "12px" }}>
            <GatewaySelector
              selectedGateway={selectedGateway}
              onChange={setSelectedGateway}
            />
          </div>
        )}
      </ConfirmModal>
      <Notification
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        snackbarSeverity={snackbarSeverity}
        setOpenSnackbar={setOpenSnackbar}
      />
      <SupportWidget />
    </>
  );
};

export default Reserve;
